module.exports = __webpack_public_path__ + "static/media/logo-gray.629849fa.svg";